import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AccountInfoModel } from '../../models/account/account-info.model';
import { RegisterAccountModel } from '../../models/account/account.model';

@Injectable({
    providedIn: 'root'
})
export class RegisterService {

    constructor(
        private http: HttpClient
    ) { }

    register(account: RegisterAccountModel) {
        return this.http.post(`${environment.api.auth}/Auth/register`, {
            email: account.email,
            password: account.password,
            confirmPassword: account.confirmPassword,
            acceptedTermsAndConditions: true,
            profileId: account.profileId,
            inviteCode: account.inviteCode
        });
    }

    registerInfo(account: AccountInfoModel) {
        return this.http.post(`${environment.api.auth}/Auth/register/update_info`, account);
    }

    verifyAccount(token: string) {
        return this.http.post(`${environment.api.auth}/Auth/validate`, {
            token
        });
    }

    loadProfiles() {
        return this.http.get(`${environment.api.auth}/Auth/register/profiles`);
    }

}
